module.exports = __webpack_public_path__ + "img/icon-thumbs-up-solid.320437e9.svg";